import React from 'react';
import Profile from '../features/Profile/Profile';

const MyProfilePage = () => (
  <div>
    <Profile />
  </div>
);

export default MyProfilePage;
